// AnimatedBulbIcon.js
import React from "react";
import { LightbulbCircleOutlined } from "@mui/icons-material";

const AnimatedBulbIcon = () => {
  return (
    <div className="bulb-container">
      <LightbulbCircleOutlined className="bulb-icon" />

      {/* Straight Light Beams Shooting Outward */}
      <div className="beams">
        <div className="beam beam1"></div>
        <div className="beam beam2"></div>
        <div className="beam beam3"></div>
        <div className="beam beam4"></div>
        <div className="beam beam5"></div>
        <div className="beam beam6"></div>
        <div className="beam beam7"></div>
        <div className="beam beam8"></div>
      </div>

      {/* Central Glow */}
      <div className="central-glow"></div>

      {/* Flash Effect */}
      <div className="flash"></div>
    </div>
  );
};

export default AnimatedBulbIcon;
